export default __webpack_public_path__ + "static/media/fox-brand.7a0d86ba.png";